import { GET_ALL_REGEX, GET_SPECIFIC_REGEX } from './mutation-types'

export default {
  [GET_ALL_REGEX]: (state, regexs) => {
    state.regexs = regexs
  },
  [GET_SPECIFIC_REGEX]: (state, regex) => {
    state.regex = regex
  },
}
